import { Modal } from "bootstrap";
import { html, LitElement } from "lit";
import { customElement, state } from "lit/decorators.js";

import ImageViewer from "../ImageViewer";

export type ImageViewerRequest = {
    imageSrc: string;
    title?: string;
    yaw?: number;
    pitch?: number;
};

@customElement("swp-image-viewer")
export class SwpImageViewer extends LitElement {
    // static styles = css`
    //     :host {
    //         display: contents;
    //     }

    //     #swp-image-viewer-modal .modal-body {
    //         display: flex;
    //         min-height: 0;
    //         flex-direction: column;
    //     }

    //     #swp-image-viewer-container {
    //         width: 100%;
    //         height: 60vh;
    //     }

    //     @media (max-width: 575.98px) {
    //         #swp-image-viewer-modal .modal-body {
    //             flex: 1 1 auto;
    //         }

    //         #swp-image-viewer-container {
    //             height: auto;
    //             min-height: 0;
    //             flex: 1 1 auto;
    //         }
    //     }
    // `;

    private _modalElement?: HTMLElement;
    private _viewerElement?: HTMLElement;

    @state()
    private _request?: ImageViewerRequest;

    @state()
    private _loading = false;

    @state()
    private _error = false;

    private _modal?: Modal;
    private _viewer?: ImageViewer;

    protected createRenderRoot(): HTMLElement | DocumentFragment {
        return this;
    }

    protected firstUpdated(): void {
        this._modalElement = this.querySelector<HTMLElement>("#swp-image-viewer-modal") ?? undefined;

        if (!this._modalElement) {
            return;
        }

        this._modal = new Modal(this._modalElement);
        this._modalElement.addEventListener("shown.bs.modal", this._resizeViewer);
        this._modalElement.addEventListener("hidden.bs.modal", this._disposeViewer);
    }

    public async show(request: ImageViewerRequest): Promise<void> {
        this._disposeViewer();
        this._request = request;
        this._loading = true;
        this._error = false;

        await this.updateComplete;
        this._viewerElement = this.querySelector<HTMLElement>("#swp-image-viewer-container") ?? undefined;

        if (!this._viewerElement) {
            this._error = true;
            return;
        }

        this._viewer = new ImageViewer({ container: this._viewerElement });
        this._modal?.show();

        try {
            await this._viewer.setPanorama(request.imageSrc, {
                yaw: request.yaw,
                pitch: request.pitch,
            });
        } catch {
            this._error = true;
        } finally {
            this._loading = false;
            this._resizeViewer();
        }
    }

    public hide(): void {
        this._modal?.hide();
    }

    private readonly _resizeViewer = (): void => {
        this._viewer?.resize();
    };

    private readonly _disposeViewer = (): void => {
        this._viewer?.dispose();
        this._viewer = undefined;
    };

    public disconnectedCallback(): void {
        this._modalElement?.removeEventListener("shown.bs.modal", this._resizeViewer);
        this._modalElement?.removeEventListener("hidden.bs.modal", this._disposeViewer);
        this._disposeViewer();
        this._modal?.dispose();
        super.disconnectedCallback();
    }

    protected render(): unknown {
        return html`
            <div
                id="swp-image-viewer-modal"
                class="modal fade modal-xl"
                tabindex="-1"
                aria-labelledby="swp-image-viewer-title"
                aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-md-down">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="swp-image-viewer-title">
                                ${this._request?.title ?? "Ansicht"}
                            </h1>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
                        </div>
                        <div class="modal-body p-0">
                            ${this._error
                                ? html`<div class="alert alert-danger m-3" role="alert">Das Panorama konnte nicht geladen werden.</div>`
                                : html`<div id="swp-image-viewer-container" style="width: 100%; height: 60vh;"></div>`}
                            ${this._loading ? html`<div class="visually-hidden">Panorama wird geladen</div>` : ""}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}
